import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { PropertyFormStore } from '../../../stores/properties/propertyFormStore';
import React, { useState } from 'react';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';
import { OneToolCardBorder } from '../../common/oneToolCard';
import { PortfolioInformationAccordion } from './portfolioInformationAccordion';
import { PortfolioInformationFormStore } from '../../../stores/portfolioInformation/portfolioInformationFormStore';

export interface PropertyInformationFormProps {
  store: PropertyFormStore;
  onDeleteClick: (propertyKey: string) => void;
  removeButtonDisabled?: boolean;
  showActions: boolean;
  quoteTypeStore: QuoteTypeStore;
}

interface PropertyInformationCardProps {
  store: QuoteTypeStore;
  portfolioFormStore: PortfolioInformationFormStore;
  showActions?: boolean;
}

export const PortfolioInformationCard = observer(
  ({
    store,
    portfolioFormStore,
    showActions = true,
  }: PropertyInformationCardProps) => {
    const editMode = portfolioFormStore.form.meta.editMode;
    const removeButtonDisabled =
      store.propertiesStore.propertyFormStores.length <= 1;

    const [expanded, setExpanded] = useState(false);

    const handleDelete = propertyKey => {
      store.propertiesStore.removeProperty(propertyKey);
    };

    const handleAcordionDelete = propertyKey => {
      store.propertiesStore.removePropertyInAccordion(propertyKey);
    };

    return (
      <OneToolCardBorder>
        <PortfolioInformationAccordion
          store={portfolioFormStore}
          propertyTypes={store.getRentalPortfoliosPropertyTypesAsString()}
          onDeleteClick={handleAcordionDelete}
          showActions={showActions}
          removeButtonDisabled={removeButtonDisabled}
          expanded={expanded}
          onExpand={expanded => setExpanded(expanded)}
        />
      </OneToolCardBorder>
    );
  }
);
